// SPDX-License-Identifier: AGPL-3.0-or-later

// Fork: the REST requests this fork makes when the gateway reports READY. A READY that arrives
// while the app is still signing in or switching account cannot make them yet: requests started
// during the switch are cancelled when it completes. Like upstream's AccountReadyWork, wait for
// the switch to be released and run them then.

import GuildCommandsStore from '@app/features/guild_commands/state/GuildCommandsStore';
import * as PersonaCommands from '@app/features/persona/commands/PersonaCommands';
import {PersonaStore} from '@app/features/persona/state/PersonaStore';
import {AccountScopedWork} from '@app/features/platform/state/AccountScopedWork';
import SignalBarStore from '@app/features/signal_bar/state/SignalBarStore';

let pending = false;

function runForkAccountReadyWork(): void {
	void PersonaCommands.fetchPersonas(true);
	void PersonaCommands.fetchPersonaSettings();
	void PersonaStore.fetchChannelStates();
}

// Upstream's promoted resume (completePromotedResume in PooledGatewayConnection.ts): on the desktop,
// the account engine kept the account's session warm, so switching to it (or starting the app on it)
// resumes that session and no READY arrives. Do here what the READY handler does for the fork. The
// switch has already dropped the previous account's personas (PersonaStore's cancellation).
export function handleForkPromotedResume(): void {
	SignalBarStore.invalidate();
	GuildCommandsStore.invalidate();
	scheduleForkAccountReadyWork();
}

export function scheduleForkAccountReadyWork(): void {
	if (AccountScopedWork.isSuspended) {
		pending = true;
		return;
	}
	pending = false;
	runForkAccountReadyWork();
}

AccountScopedWork.registerTransition({
	suspend: () => {
		pending = false;
	},
	resume: () => {},
	released: () => {
		if (!pending) {
			return;
		}
		pending = false;
		SignalBarStore.invalidate();
		GuildCommandsStore.invalidate();
		runForkAccountReadyWork();
	},
});
